import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ErrorStrings } from 'src/app/constants/form.constants';
import { Alert } from 'src/app/interfaces/alert';
import { AuthManagerService, ClaimAccountParams } from 'src/app/services/auth-manager/auth-manager.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { FeatureFlagsService } from 'src/app/services/feature-flag/feature-flag.service';

@Component({
  selector: 'app-tok-register',
  templateUrl: './tok_claim_account.component.html',
  styleUrls: ['./tok_claim_account.component.scss']
})
export class TokClaimAccountComponent implements OnInit {
  hideConfirmPassword: boolean = true;
  hidePassword: boolean = true;
  useRebrandedLayout: boolean;

  public loading = false;
  public errorStrings = ErrorStrings;
  public alert: Alert = null;
  public model = {
    password: '',
    emailAddress: '',
  };

  private _emailAddress: string;
  private _emailVerificationCode: string;
  // A keeper can only accept a ToK while on the premium plan, so the fee matches the premium annual price.
  public tokFee: string;

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _authManager: AuthManagerService,
    private _router: Router,
    private featureFlagService: FeatureFlagsService,
    private configService: ConfigService
  ) {
    this.tokFee = this.configService.getTextFromKey('2-plan-yearly-price');
    this.useRebrandedLayout = this.featureFlagService.isEnabled('useRebrandedLayout');
  }
  
  ngOnInit(): void {
    const queryParams = this._activatedRoute.snapshot.queryParams;
    if (
      !queryParams ||
      (queryParams && !queryParams.emailAddress) ||
      (queryParams && !queryParams.evc)
    ) {
      this.alert = {
        type: 'danger',
        message:
          'An error has occurred, the URL is invalid! Please try to open the claim email again, ' +
          'in case the issue still persist please feel free to contact us.',
      };
    } else {
      this.model.emailAddress = queryParams.emailAddress;
      this._emailAddress = queryParams.emailAddress;
      this._emailVerificationCode = queryParams.evc;
    }
  }

  public claimAccount() {
    this.closeAlert();
    this.loading = true;

    const claimAccountParams: ClaimAccountParams = {
      password: this.model.password,
      emailAddress: this._emailAddress,
      emailVerificationCode: this._emailVerificationCode,
    };
    this._authManager
      .claimAccount(claimAccountParams)
      .subscribe({
        next: () => {
          this.loading = false;
          this.alert = {
            type: 'success',
            message:
              "Your account was activated, you'll get redirected in a few seconds!",
          };

          setTimeout(() => {
            this._router.navigate(['/tok-login'], { queryParams: { email: this._emailAddress } });
          }, 2000);
        },
        error: (err) => {
          if (err instanceof HttpErrorResponse && err.status === 400) {
            this.loading = false;
            this.alert = {
              type: 'danger',
              message: 'Something went wrong!',
            };

            if (err.error.error_code === 'invalid_data') {
              this.alert = {
                type: 'danger',
                message: err.error.error_message ?? 'An unexpected error occurred.'
              };
            }

            if (err.error.error_code === 'weak_password') {
              this.alert = {
                type: 'danger',
                message: err.error.error_message ?? 'Your password is too simple. Please use a mix of uppercase and lowercase letters, numbers, and special characters.'
              };
            }
          } else if (err instanceof HttpErrorResponse && err.status === 409) {
            this.loading = false;
            // User already registered: Redirect to login form
            this.alert = {
              type: 'success',
              message: "Success! You'll get redirected in a few seconds!",
            };

            setTimeout(() => {
              this._router.navigate(['/tok-login'], {
                queryParams: { email: this._emailAddress },
              });
            }, 2000);
          } else {
            this.loading = false;
            this.alert = {
              type: 'danger',
              message: 'An error has occurred. Please try again later.',
            };
          }
        }
      })
  }

  public closeAlert() {
    this.alert = null;
  }

}
